export default __webpack_public_path__ + "static/media/img-ovato.e2697102.png";